import moment from "moment";
import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ClassDataService from '../../services/class/ClassService';
import { Link } from "react-router-dom";

const ClassesPanel = ({classes, student, props}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [currentClassDates, setCurrentClassDates] = useState();

  useEffect(() => {
    //fetch dates for that class
    if (classes?.[tabIndex]) {
        console.log(`selected class ${classes?.[tabIndex]?.title}`)
        setCurrentClassDates([]);
        //get the dates for that class
        
        const bg = async() => {
            const currentClass = classes?.[tabIndex];
            if (currentClass.dates) {
                setCurrentClassDates(currentClass.dates);
            } else {
                const fullClass = await ClassDataService.getForStudent(classes?.[tabIndex].classId, student.id)
                classes[tabIndex].dates = fullClass.dates;
                console.log('We gots the dates', fullClass);
                setCurrentClassDates(fullClass.classDates);
            }
            
        }
        
        bg();
    }
    
  }, [tabIndex]);

  const renderClassPanel = (clazz) => {
      console.log('render class panel', clazz.dates);
    return (
      <TabPanel style={{padding: 10}}>
        <h4>{clazz.title}</h4>
        <div className="classPanelPair">
            <div className="classPanelLabel">Teacher</div>
            <div className="classPanelValue"><Link to={`/teachers`}>{clazz.teacher}</Link></div>
        </div>
        <div className="classPanelPair">
            <div className="classPanelLabel">School Year</div>
            <div className="classPanelValue">{clazz.schoolYear}</div>
        </div>
        <div className="classPanelPair">
            <div className="classPanelLabel">Semester</div>
            <div className="classPanelValue">{clazz.semester}</div>
        </div>
        <div className="classPanelPair">
            <div className="classPanelLabel">Day</div>
            <div className="classPanelValue">{clazz.day}</div>
        </div>

        <div className="classPanelPair">
            <div className="classPanelLabel">Dates</div>
            <div className="classPanelValue">
                <div style={{display: 'flex', flexDirection: 'row', fontWeight: 'bold', backgroundColor: '#63a3be', borderWidth: 1, borderColor: 'black'}}>
                    <div style={{flex: 2}}>Date</div>
                    <div style={{flex: 1,}}>Attended</div>
                    <div style={{flex: 3,}}>Themes</div>
                </div>
                {currentClassDates?.map(d => {
                const rowStyle = {display: 'flex'};
                const dateToCheck = moment(d.classDate);
                if (moment(dateToCheck).isAfter()) {
                    return (
                        <div style={{display: 'flex', flexDirection: 'row', fontWeight: 'bold'}}>
                            <div style={{flex: 2}}>{dateToCheck.format('DD.MM.YYYY')}</div>
                            <div style={{flex: 1}}>{d.attendance ? d.attendance : ''}</div>
                            <div style={{flex: 3}}>{d.themes ? d.themes.map(t => t.name).join(', ') : ''}</div>
                        </div>
                    );
                } else {
                    return (
                        <div style={{display: 'flex', flexDirection: 'row', color: 'gray'}}>
                            <div style={{flex: 2}}>{dateToCheck.format('DD.MM.YYYY')}</div>
                            <div style={{flex: 1}}>{d.attendance ? d.attendance : ''}</div>
                            <div style={{flex: 3}}>{d.themes ? d.themes.map(t => t.name).join(', ') : ''}</div>
                        </div>
                    )
                }
                
            })}</div>
        </div>
      </TabPanel>
    )
  };

  const truncate = (input, to) => input.length > to ? `${input.substring(0, to)}...` : input;

  if (classes.length) {
    return (
        <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          {classes.map(c => <Tab>{truncate(c.title, 15)} ({c.schoolYear} {c.semester})</Tab>)}
        </TabList>
        {classes.map(c => renderClassPanel(c))}
      </Tabs>
    )
  } else {
    return (<div>This student is not currently enrolled in any classes</div>)
  }
};

export default ClassesPanel;